import * as Types from "../../../constants";
import produce from "immer";

let initialState = {
  listTaxonony: [],
  listVariantTaxonomy: [],
  options: [],
  initListVariantTaxonomy: [],
  listProductVariations: [],
};
export default (state = initialState, action = {}) => {
  return produce(state, draft => {
    switch (action.type) {
      case Types.GET_LIST_TAXONOMY:
        draft.listTaxonony = action.taxonomy.data;
        break;
      case Types.GET_LIST_VARIANT_TAXONOMY:
        draft.listVariantTaxonomy = action.property.data;
        draft.initListVariantTaxonomy = action.property.data;
        break;
      case Types.SAVE_PRODUCT_VARIATIONS:
        draft.listProductVariations = action.data;
        break;
      case Types.UPDATE_LIST_VARIANT_TAXONOMY:
        draft.listVariantTaxonomy = action.data;
        break;
      case Types.UPDATE_OPTIONS:
        draft.options = action.data;
        break;
      default:
        return state;
    }
  })
}

